interface MediaCaptureOptions {
  interval: number
}

interface TimerMessage {
  type: string
  data?: {
    interval: number
  }
}

class MediaCapture {
  private interval: number

  private stream: MediaStream | null

  private video: HTMLVideoElement

  private canvas: HTMLCanvasElement

  private context: CanvasRenderingContext2D

  private timer: Worker

  constructor(options: MediaCaptureOptions) {
    const { interval } = options

    this.interval = interval
    this.stream = null

    this.video = document.createElement('video')
    this.video.autoplay = true

    this.canvas = document.createElement('canvas')
    this.context = this.canvas.getContext('2d', {
      willReadFrequently: true,
    })!

    this.timer = new Worker('assets/js/timer.js')
    this.timer.onmessage = (event: MessageEvent<TimerMessage>) => {
      const message = event.data
      if (message.type === 'tick') {
        this.drawShareScreen()
      }
    }
  }

  getCanvas(): HTMLCanvasElement {
    return this.canvas
  }

  setStream(stream: MediaStream | null): void {
    this.stream = stream
    this.video.srcObject = stream

    if (stream) {
      this.timer.postMessage({
        type: 'start',
        data: {
          interval: this.interval,
        },
      })
    } else {
      this.timer.postMessage({
        type: 'stop',
      })
    }
  }

  terminate(): void {
    this.timer.terminate()
  }

  private drawShareScreen(): void {
    if (!this.stream?.active) {
      return
    }

    if (this.video.readyState !== 0) {
      const width = this.video.videoWidth
      const height = this.video.videoHeight

      this.canvas.width = width
      this.canvas.height = height

      this.context.drawImage(this.video, 0, 0, width, height)
    }
  }
}

export { MediaCapture }
